
import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import _ from "lodash";
import SweetAlert from 'react-bootstrap-sweetalert';
import $ from "jquery";
// import axios from 'axios';
// import Multiselect from 'multiselect-dropdown-react';
// import Breadcrumb from '../common/breadcrumb.component';
// import {Redirect} from 'react-router-dom';
import { AgGridReact } from '@ag-grid-community/react';
import {AllModules} from '@ag-grid-enterprise/all-modules';
// //import {ChartMenu} from '@ag-grid-enterprise/charts/dist/es6/chartAdaptor/chartComp/menu/chartMenu';
import Select from 'react-select';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
// import { getHyphenYYYYMMDDHHMMSS,getYYYYMMDDHHMMSS } from '../common/utils';
import { getDDMMYYYY, 
	getDDMMYYYYHHMMSS, 
	getYYYYMMDD, 
	getYYYYMMDDHHMMSS, 
	getHyphenYYYYMMDDHHMMSS,
	getHyphenDDMMMYYYYHHMM,
	getHyphenYYYYMMDD, 
	getHyphenDDMMYYYYHHMMSS, 
	getHyphenDDMMYYYY,
	getDDMMMYYYYHHMMDefault } from '../common/utils'; 
import MarkerClusterer from "@google/markerclusterer";
var redirectURL = require('../redirectURL');
var infoBox = require('../common/google-infowindow');
var oms = require(`npm-overlapping-marker-spiderfier/lib/oms.min`);
var googleAnalytics = require("../common/googleanalytics");
var moment = require('moment');
var drawingManager;
var selectedShape;
var colors = ['#1D9567', '#1692A5', '#F4D749','#F73E3E', '#B7B3B3' ];
var selectedColor;
var colorButtons = {};
var fencingLength=0;
var mapZoom=10;
var geoFencingArea;
var eventcoords;
var coordinates=[];
var geoFencingAreaArr = [];
var selectedRowData="";
var map;
const carrieroptions = [
	  { value: 'On Trip', label: 'On Trip' },
      { value: 'Empty', label: 'Empty' },
      { value: 'Both', label: 'Both' }
	];
var geocoords =[];
var markersList = [];

const cipher = (salt) => {
	const textToChars = text => text.split('').map(c => c.charCodeAt(0));
	const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
	const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
	try {
		return text => text.split('')
			.map(textToChars)
			.map(applySaltToChar)
			.map(byteHex)
			.join('');
	}
	catch (e) {

	}

}

var encode = cipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");

export default class EditWeatherEvent extends Component {

    constructor(props) {
        super(props);

        this.state = {
			modules: AllModules,
            // truckData:this.props.truckInfo,
            defaultColDef: {
                sortable: true,
                filter: true,
                editable: true,
			},
			rowData:[],
            rowSelection:'multiple',
      	    rowModelhighchartoptionsType: 'enterprise',
			rowGroupPanelShow: 'always',
            statusBar: {
				statusPanels: [
					{
					statusPanel: "agTotalAndFilteredRowCountComponent",
					align: "left"
					},
					{
					statusPanel: "agTotalRowCountComponent",
					align: "center"
					},
					{ statusPanel: "agFilteredRowCountComponent" },
					{ statusPanel: "agSelectedRowCountComponent" },
					{ statusPanel: "agAggregationComponent" }
				]
            },
            paginationPageSize:50,
            sideBar: {
				toolPanels: [
					{
					id: "columns",
					labelDefault: "Columns",
					labelKey: "columns",
					iconKey: "columns",
					toolPanel: "agColumnsToolPanel"
					},
					{
					id: "filters",
					labelDefault: "Filters",
					labelKey: "filters",
					iconKey: "filter",
					toolPanel: "agFiltersToolPanel"
					}
				]
			},
			pageTitle: "Emergency Alerts",
			eventGridAction: "gridAction",
			eventCounterAction: "counterAction",
			eventFormAction: "formAction",
			currentDepartmentCode: null,
			currentDepartmentTitle: null,
            routemap:'',
            startAlert:"",
			endAlert:"",
			user_email:"",
			show : false,
			type : "",
			title : "",
            notifyduration : 5,
            notifyfirstto:"",
			notifyfirstcc:"",
			previousScreenPath :"",
        	departments:[],
        	coords:[],
			geo_name:'',
			editedEventID:"",
            geo_type:'',
            endAlertVal:"",
			fence_type:'',
			event:"",
        	dept_code:"",
			notify:'',
			carrier:"",
			oldEvent : "",
			erroMessage:'',
			notify_transporter:"",
			redirectpage:'',
			oldStartAlert:"",
			oldEndAlert:"",
			triptype :{"value":1,"label":"ALL"},
			showtruckopts:"show-n",
			setshow:false,
			truckscoordinates:[],
			plantLocations : [],		
			weatherData: [],
			displayWeatherForecast: false,
			weatherMarkers: [],
			overly:'show-n',
			availableTrucks: []
    	      
        };
        this.showMap = this.showMap.bind(this);
        this.applyCoords = this.applyCoords.bind(this);
        this.checkHandler = this.checkHandler.bind(this);
        this.checkNotifyHandler = this.checkNotifyHandler.bind(this);
        this.startAlertFormat = this.startAlertFormat.bind(this);
		this.endAlertFormat = this.endAlertFormat.bind(this);
		this.disableevent = this.disableevent.bind(this);
	}
	logPageView = () => {
		try {
			if (googleAnalytics.page.enableGA) {
				googleAnalytics.logPageView();
				let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
				let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
				let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
				this.setState({eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction});
			} else {
				console.log("GA disabled...");
			}
		} catch(error) {
			console.error("Error occured while logging to GA, error = ", error);
		}
	}
    componentDidMount(){
		loadDateTimeScript()
		if (googleAnalytics.page.enableGA) {
			this.logPageView();
		}
		let deptcode = localStorage.getItem("dept_code");
		let useremail = localStorage.getItem("email");

		
		
		var inputEventval1 = window.atob(this.props.match.params.eventname);
		var pageType = this.props.match.params.pageType;
		var inputEventval = inputEventval1.split(",")[0];
		var parentPath = inputEventval1.split(",")[1];

		var department = parentPath;
		department = department.replace(/"/g,"");
		if(department != "LOG-PRT" && department != "LOG-SC" && department != "LOG-TNP" && department != "SNDG"){
			department = "ALL";
		}
		if(department != "LOG-PRT" && department != "LOG-SC" && department != "LOG-TNP" && department != "SNDG"){
			department = inputEventval1.split(",")[1];
		}
		var reqparams = {
            dept_code : encode(department),
            eventID : inputEventval,
        }
		console.log(reqparams, "reqparams")
        redirectURL.post("/weather/getEventData",reqparams).then((response)=>{
            console.log(response.data);
			var startalertval = response.data[0].start_alert;
			if(startalertval !=undefined && startalertval !='')
			{
				if(startalertval.includes("T") == true)
				{
					// startalertval = startalertval.split("T");
					// var time = startalertval[1];
					// startalertval = startalertval[0];
					// startalertval = startalertval.split("-")[2]+"-"+startalertval.split("-")[1]+"-"+startalertval.split("-")[0]+" "+time;
					startalertval = getHyphenDDMMYYYYHHMMSS(startalertval)
				}
				else
				{
					
				}
			}
			var endalertval = response.data[0].end_alert;
			if(endalertval !=undefined && endalertval !='')
			{
				if(endalertval.includes("T") == true)
				{
					// endalertval = endalertval.split("T");
					// var time = endalertval[1];
                    // endalertval = endalertval[0];
					// endalertval = endalertval.split("-")[2]+"-"+endalertval.split("-")[1]+"-"+endalertval.split("-")[0]+" "+time;
					endalertval = getHyphenDDMMYYYYHHMMSS(endalertval)
				}
				else
				{
					
				}
			}
			// try
			// {
			// 	startalertval = startalertval.split(" ")[0].split("-")[2]+"-"+startalertval.split(" ")[0].split("-")[1]+"-"+startalertval.split(" ")[0].split("-")[0]+" "+startalertval.split(" ")[1].split(":")[0]+":"+startalertval.split(" ")[1].split(":")[1]
			// 	endalertval = endalertval.split(" ")[0].split("-")[2]+"-"+endalertval.split(" ")[0].split("-")[1]+"-"+endalertval.split(" ")[0].split("-")[0]+" "+endalertval.split(" ")[1].split(":")[0]+":"+endalertval.split(" ")[1].split(":")[1]
			// }
			// catch(e){}
           
			$("#start-alert-id").val(startalertval);
			$("#event-id").val(response.data[0].event);
			$("#end-alert-id").val(endalertval);
			$("#notifyFirst").val(response.data[0].notify_via_email);
			$("#notifyFirstcc").val(response.data[0].notify_via_email_cc);
			$("#notify-duration-id").val(response.data[0].notify_duration);
			coordinates = response.data[0].coordinates;
			
			if(response.data[0].notify_transporter == "yes"){
				$("#notifyTransporter").prop("checked",true);
			}
			if(response.data[0].notify_trucks == "yes")
			{
				$("#notifyTrucks").prop("checked",true);
			}
			eventcoords = response.data[0].coordinates;
			// console.log(eventcoords);
			var previousUrl = "pre";
			if(department == "ALL"){
				if(this.props.match.path == "/sndweatheralerts"){
					department = "SNDG";
				}
				if(this.props.match.path == "/prtweatheralerts"){
					department = "LOG-PRT";
				}
			}
			// console.log(parentPath);
			if(pageType == 1)
			{
				previousUrl = "/allweatheralerts"
			}
			else{
				if(parentPath == "SNDG"){
					previousUrl = "/sndweatheralerts"
				}
				if(parentPath == "LOG-PRT"){
					previousUrl = "/prtweatheralerts"
				}
			}
			this.setState({
				// availableTrucks: response.data[1],
				event : response.data[0].event,
				editedEventID : response.data[0]._id,
				oldEvent : response.data[0].event,
				dept_code : department,
				previousScreenPath : previousUrl,
				carrier : response.data[0].carrier_type,
				startAlert : response.data[0].start_alert,
				endAlert : response.data[0].end_alert,
				notifyfirstto : response.data[0].notify_via_email,
				notifyfirstcc : response.data[0].notify_via_email_cc,
				notifyduration : response.data[0].notify_duration,
				notifyTransporter : response.data[0].notify_transporter,
				user_email : useremail,
				pageType : pageType,
				oldStartAlert : response.data[0].start_alert,
				oldEndAlert : response.data[0].end_alert,
            })
			this.showMap();
			this.handleFilteronLoad();
        }).catch(function(error){
            console.log(error);
		})
		
        // setTimeout(async () => {
		// 	await 
		// },2000)
	}
	onClickHideAll(){
		this.setState({
			loadshow:'show-n',
			overly:'show-n',
		});
	}
    showMap =() =>{
    	this.renderMap();
    }
    renderMap = () => {
    	
           loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyA08YKZGPl0ii3K-t4_guTbdtjscGgdPns&libraries=places,drawing&callback=initMap");
           window.initMap = this.initMap		   
	}
    initMap = () => {
		//console.log("coordinates ", this.state.coordinates)
    	// var coordsvalues;
		var geoFencingObj;
		geoFencingObj = coordinates;
		// console.log("here coordinates",geoFencingObj);
		 map = new window.google.maps.Map(document.getElementById('map_canvas'), {
			zoom: 7,
			center: new window.google.maps.LatLng(28.497236,77.062363),
			mapTypeId: window.google.maps.MapTypeId.ROADMAP,
			mapTypeControl: true,
			mapTypeControlOptions: {
				style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
				position: window.google.maps.ControlPosition.TOP_RIGHT
			},            
			disableDefaultUI: true,
			zoomControl: true
		});
		if(geoFencingObj.length > 0)
		{
		 map = new window.google.maps.Map(document.getElementById('map_canvas'), {
			zoom: 7,
			center: new window.google.maps.LatLng(geoFencingObj[0][0].lat,geoFencingObj[0][0].lng),
			mapTypeId: window.google.maps.MapTypeId.ROADMAP,
			mapTypeControl: true,
			mapTypeControlOptions: {
				style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
				position: window.google.maps.ControlPosition.TOP_RIGHT
			},            
			disableDefaultUI: true,
			draggingCursor: 'pointer',
			drawingMode:null,
			drawingControl : false,
			zoomControl: true
		});
		}
		else{
			this.setState({
				loadshow:"show-n",
				overlay:"show-n",
			});
		}
		
  		//added by nanda for places dropdown...
  	    var input = document.getElementById('search');
          var searchBox = new window.google.maps.places.SearchBox(input);
          map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

          // Bias the SearchBox results towards current map's viewport.
          map.addListener('bounds_changed', function() {
        	 
            searchBox.setBounds(map.getBounds());
          });
  		
  		var markers = [];
  		 searchBox.addListener('places_changed', function() {
            var places = searchBox.getPlaces();

            if (places.length == 0) {
              return;
            }

            // Clear out the old markers.
            markers.forEach(function(marker) {
              marker.setMap(null);
            });
            markers = [];
  // For each place, get the icon, name and location.
            var bounds = new window.google.maps.LatLngBounds();
            places.forEach(function(place) {
              if (!place.geometry) {
                console.log("Returned place contains no geometry");
                return;
              }
              var icon = {
                url: place.icon,
                size: new window.google.maps.Size(71, 71),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(17, 34),
                scaledSize: new window.google.maps.Size(25, 25)
              };

              // Create a marker for each place.
              markers.push(new window.google.maps.Marker({
                map: map,
                icon: icon,
                title: place.name,
                position: place.geometry.location
              }));

              if (place.geometry.viewport) {
                // Only geocodes have viewport.
            	  
                bounds.union(place.geometry.viewport);
              } else {
            	  
                bounds.extend(place.geometry.location);
              }
            });
            map.fitBounds(bounds);
          });		
		  //End of adding by nanda
		
		  var markTrucks = this.state.truckscoordinates
		  var markWeathers = this.state.weatherData
		  markTrucks = markTrucks.map((e)=>{
			  e['marker_type'] = "truck";
			  return e;
		  })
		  markWeathers = markWeathers.map((e)=>{
			  e['marker_type'] = 'weather'
			  return e;
		  })
		  var mapMarkersFlag = []
		  const {setshow : truckClicked, displayWeatherForecast : weatherClicked} = this.state
		  if (truckClicked && weatherClicked){
			//   alert("Concatenating...!!")
			  mapMarkersFlag = markTrucks.concat(markWeathers)
		  }
		  else{
			  if(truckClicked){
				  mapMarkersFlag = markTrucks
			  }
			  else if(weatherClicked){
				  mapMarkersFlag = markWeathers
			  }
		  }		
		// console.log(mapMarkersFlag, "mapMarkersFlag")
		var markers = mapMarkersFlag.map((marker) => {
			console.log("markerLoop", marker)		
			var url="";
			var iconName = "";
			var truckText =  "";
			var color =  "";
			var image = "";

			//weather icons
			if(marker.marker_type == "weather"){
				if (marker.description !== undefined){
					if(marker.description.includes("Thunderstorm")){
						url = require("../../assets/icons/thunderstorm.png")
					}
					else if(marker.description.includes("Heavy Rain and Strong Winds")){
						url = require("../../assets/icons/wind.png")
					}
					else if(marker.description.includes("Heavy Rain")){
						url = require("../../assets/icons/Heavyrain.png")
					}
					else if(marker.description.includes("Cyclone")){
						url = require("../../assets/icons/cyclone.png")
					}
					else if(marker.description.includes("Hailstroms")){
						url = require("../../assets/icons/hailstorm.png")
					}
					else if(marker.description.includes("Sandstorm") || marker.description.includes("Duststorm")){
						url = require("../../assets/icons/sandstorm.png")
					}
				}
				// console.log("Weather Marker ../../assets/icons/Heavyrain.png", )
			}
			//weather icons
			if(marker.marker_type == "truck"){
				truckText =  marker.truck_no;
				color =  "#333333";
				url =  require('../../assets/icons/truck_na_24.png');
				// image =  require('../../assets/icons/truck_na_24.png');
				var contentarr = []
				var headerTitle = truckText
				//contentarr.push({"key":"Truck No", "value":marker.truck_no});
				contentarr.push({"key":"Transporter Name", "value":marker.transporter_name});
				//contentarr.push({"key":"Distance from geofence", "value":marker.distance});
				contentarr.push({"key":"GPS Provider", "value":marker.actual_lspuser});
				contentarr.push({"key":"Last Packet Time", "value":getHyphenDDMMMYYYYHHMM(marker.timestamp)});
				contentarr.push({"key":"Speed (km/h)", "value":Math.ceil(marker.speed)});
				contentarr.push({"key":"Address", "value":marker.area+", "+marker.state});
				
				var contentString = infoBox(image, headerTitle, contentarr, '')
	
				var infowindow = new window.google.maps.InfoWindow({
					content: contentString
				});			
				

			}
			

			iconName = {
				url: url, // url
				scaledSize: new window.google.maps.Size(32, 32), // scaled size
				origin: new window.google.maps.Point(0,0), // origin
				anchor: new window.google.maps.Point(0, 0) // anchor
			};
			
			var markerLatlng = new window.google.maps.LatLng(parseFloat(marker.latitude), parseFloat(marker.longitude));
			var mark = new window.google.maps.Marker({
							position: markerLatlng,
							map: map,
							icon: iconName
						});
			if(marker.marker_type == "truck")
			{
				mark.addListener('click', function() {
					infowindow.open(map, mark);
				});
			}
			else if(marker.marker_type == "weather")
			{
				var weatherInfowindow = new window.google.maps.InfoWindow({
					content: "<div class='weather-marker-tooltip'><div class='forecast-date'><label class='forecast-labels'> Forecast Date : </label> "+moment.parseZone(new Date(marker.forecast_date)).format("DD-MMM-YYYY")+"</div><div class='address'> <label class='forecast-labels'>Address :</label> "+marker.address+"</div><div class='weather-desc'><label class='forecast-labels'> Weather : </label> "+marker.description+"</div><div class='last-updated'><label class='forecast-labels'> Last Updated On : </label> "+getHyphenDDMMMYYYYHHMM(marker.last_updated_on)+"</div>"
				});
				window.google.maps.event.addListener(mark, 'mouseover', function() {
					weatherInfowindow.open(map,mark);
				});
				window.google.maps.event.addListener(mark, 'mouseout', function() {
					weatherInfowindow.close();
				});
			}
			return mark		
			
		});
		
		var eventtrigger = document.getElementsByClassName('truck');
		new MarkerClusterer(map, markers,
            {minimumClusterSize: 4,imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
		  var searchBox = new window.google.maps.places.SearchBox(eventtrigger);
		  map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(eventtrigger);
		if(this.state.plantLocations.length > 0){
			this.state.plantLocations.map(function(params){
				var plant = {
				url: require("../../assets/icons/"+params.icon), // url
				scaledSize: new window.google.maps.Size(32,32), // scaled size
				origin: new window.google.maps.Point(0,0), // origin
				anchor: new window.google.maps.Point(0, 0) // anchor
				};
				var coords = JSON.parse(params.coordinates);
				var plantmarker = new window.google.maps.Marker({
					position: new window.google.maps.LatLng(coords.lat,coords.lng),
					map: map,
					icon: plant,
					title : params.plant_name
				});
				// var cityCircle = new window.google.maps.Circle({
				// strokeColor: '#9fc9b9',
				// strokeOpacity: 0.3,
				// strokeWeight: 2,
				// fillColor: '#9fc9b9',
				// fillOpacity: 0.6,
				// map: map,
				// center:coords,
				// radius: 50 * 1000
				// });
			})
		}
		  for(var i=0;i<geoFencingObj.length;i++)
		  {
			if(geoFencingObj[i].length != 1)
			{
				geoFencingArea = new window.google.maps.Polygon({
					paths: geoFencingObj[i],
					editable: true,
					strokeColor: '#1D9567',
					strokeOpacity: 0.70,
					strokeWeight: 0,
					fillColor: '#1D9567',
					fillOpacity: 0.35,
					draggable:false,
					draggingCursor:null,
					
					});
					geoFencingAreaArr[i] = new window.google.maps.Polygon({
					paths: geoFencingObj[i],
					editable: true,
					strokeColor: '#1D9567',
					strokeOpacity: 0.70,
					strokeWeight: 0,
					fillColor: '#1D9567',
					fillOpacity: 0.35,
					draggable:false,
					draggingCursor:null,
					});
				console.log("geoFencingArea[i] ",geoFencingAreaArr[i]);
				//geoFencingArea.setMap(map);
				geoFencingAreaArr[i].setMap(map);
				fencingLength=geoFencingObj[i];
				console.log("test ",geoFencingArea.getPath());
				// geoFencingAreaArr.push(geoFencingArea);
				console.log("fencingLength ",fencingLength)
				window.google.maps.event.addListener(geoFencingAreaArr[i].getPath(),'insert_at',getPolygonCoords);
				window.google.maps.event.addListener(geoFencingAreaArr[i].getPath(),'set_at', getPolygonCoords);
			}
			else{
				console.log(geoFencingObj[i][0].lat,geoFencingObj[i][0].lng);
				var marker = new window.google.maps.Marker({
					position: new window.google.maps.LatLng(geoFencingObj[i][0].lat,geoFencingObj[i][0].lng),
					map: map,
					// icon: iconName,
					// title : ""+params.address+","+params.forecast_date+","+params.description
				});
				geoFencingAreaArr[i] = new window.google.maps.Polygon({
					paths: geoFencingObj[i],
					editable: true,
					strokeColor: '#1D9567',
					strokeOpacity: 0.70,
					strokeWeight: 0,
					fillColor: '#1D9567',
					fillOpacity: 0.35,
					draggable:false,
					draggingCursor:null,
					});
					geoFencingAreaArr[i].setMap(map);
				window.google.maps.event.addListener(geoFencingAreaArr[i].getPath(),'insert_at',getPolygonCoords);
				window.google.maps.event.addListener(geoFencingAreaArr[i].getPath(),'set_at', getPolygonCoords);
			}
			 
		
		  }
	      var polyOptions = {
            strokeWeight: 0,
            fillOpacity: 0.70,
            editable: true
          };
          // Creates a drawing manager attached to the map that allows the user to draw
          // markers, lines, and shapes.
          drawingManager = new window.google.maps.drawing.DrawingManager({
			
            drawingMode: null,
            drawingControlOptions: {
              drawingModes: [
                window.google.maps.drawing.OverlayType.POLYGON
			  ],	
			  
            },
            markerOptions: {
              draggable: true
            },
            polylineOptions: {
              editable: true
            },
            rectangleOptions: polyOptions,
            circleOptions: polyOptions,
            polygonOptions: polyOptions,
            map: map
          });

          window.google.maps.event.addListener(drawingManager, 'overlaycomplete', function(e) {
              if (e.type != window.google.maps.drawing.OverlayType.MARKER) {
              // Switch back to non-drawing mode after drawing a shape.
            //   drawingManager.setDrawingMode(null);
			  // To hide:
			//   drawingManager.setOptions({drawingMode: null, drawingControl: false});
              drawingManager.setOptions({
                drawingControl: true
              });

              // Add an event listener that selects the newly-drawn shape when the user
              // mouses down on it.
              var newShape = e.overlay;
              newShape.type = e.type;
              window.google.maps.event.addListener(newShape, 'click', function() {
                setSelection(newShape);
              });
              setSelection(newShape);
              console.log("selectedShape",newShape);
  			  fencingLength = selectedShape.getPath().getLength();
  			  //console.log("fencingLength ", fencingLength)
  				var latlngObj=[];
	  			var htmlStr = "";
	  	        for (var i = 0; i < fencingLength; i++) {
	  				var each_lat_lng = selectedShape.getPath().getAt(i).toUrlValue(5).split(',');
	  				var in_latlng_array={"lat":parseFloat(each_lat_lng[0]),"lng":parseFloat(each_lat_lng[1])};
	  				latlngObj.push(in_latlng_array);
				}
				coordinates.push(latlngObj);  
	  			
            }
              
          });
          
        var bounds = new window.google.maps.LatLngBounds();
		var i1;
		var j1;
		for(i1=0;i1<geoFencingObj.length;i1++){
			if(geoFencingObj[i1].length != 1)
			{
				for(j1=0;j1<geoFencingObj[i1].length;j1++)
				{
					bounds.extend(new window.google.maps.LatLng(geoFencingObj[i1][j1].lat,geoFencingObj[i1][j1].lng));
				}
			}
			
		}
		try{
			if(bounds.Za.i != 1 && bounds.Ua.i !== 180 )
			{
				map.fitBounds(bounds);
			}
		}catch(e){console.log(e)}
		
		
		
          // Clear the current selection when the drawing mode is changed, or when the
          // map is clicked.
  		window.google.maps.event.addListener(drawingManager, 'drawingmode_changed', function(){
  			clearSelection()
  		});
  		window.google.maps.event.addListener(map, 'click', function(){
  			clearSelection()
  		});
  		map.addListener('zoom_changed', function() {
            mapZoom=map.getZoom();
        });	

    }
    
    onGridReady = params => {
		this.gridApi = params.api;
		
	    //console.log("Grid is: ", params);
	    this.gridColumnApi = params.columnApi;
	};
	

	onGridState = () =>{
		 //console.log(this.gridApi);
		
		 /*Get  Current Columns State and Store in this.colState */
		   this.colState = this.gridColumnApi.getColumnState();

		 /*Get Current RowGroup Columns State and Store in this.rowGroupState */
		   this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

		 /*Get Current Pivot Columns State and Store in this.pivotColumns, 
		  * User should enable the Pivot mode.*/
		   this.pivotColumns = this.gridColumnApi.getPivotColumns();
		 		   
		 /*Get Current Filter State and Store in window.filterState */
		   window.filterState = this.gridApi.getFilterModel();
		   this.gridApi.setFilterModel(window.filterState);
		   
		   
		   
	}
    
    fenceTypeHandler = (event) => {
    	console.log(event.target)
    }

	changeCarrier = geo_type => {

    	this.setState(
	      { geo_type },
	      () => console.log(`Option selected:`, this.state.carrier)
	    );
	}

    changeHandler = (event) => {
    	this.setState({
		  carrier:event.value
		});
    }
    startAlertFormat(event){
        console.log("changed");
        console.log(event.target.value);
        let originalDate = event.target.value
        if(originalDate != "")
        {
            let dateval = originalDate.split(" ")[0].split("-");
            let timeval = originalDate.split(" ")[1];
            let formattedDate = dateval[2]+"-"+dateval[1]+"-"+dateval[0]+" "+timeval+":00";
            let endDate = dateval[1]+"-"+dateval[0]+"-"+dateval[2];
            console.log(endDate);
            var endDateVal = new Date(endDate);
            endDateVal = moment.parseZone(new Date(endDateVal.setDate(endDateVal.getDate()+5))).format('YYYY-MM-DD HH:mm:ss');
            endDateVal = endDateVal.split(" ")[0].split("-")[2]+"-"+endDateVal.split(" ")[0].split("-")[1]+"-"+endDateVal.split(" ")[0].split("-")[0]+" "+timeval ;
			console.log(endDateVal);
			$("#end-alert-id").val("");
			$("#end-alert-id").val(endDateVal);
            this.setState({
                startAlert : formattedDate,
                // endAlertVal : endDateVal
            })
            console.log(formattedDate);
        }
    }
    endAlertFormat = (event) =>{
        console.log("changed");
        console.log(event.target.value);
        let originalDate = event.target.value
        if(originalDate != "")
        {
            let dateval = originalDate.split(" ")[0].split("-");
            let timeval = originalDate.split(" ")[1];
            let formattedDate = dateval[2]+"-"+dateval[1]+"-"+dateval[0]+" "+timeval+":00";
            this.setState({
                endAlertVal : formattedDate
            })
            console.log(formattedDate);
        }
    }
    checkHandler = (event) => {
    	
    	let name = event.target.name;
		let value = event.target.value;
    	this.setState({[name]:value});
    }
    changeInputHandler = (event) => {
    	let name = event.target.name;
		let value = event.target.value;
    	this.setState({[name]:value});
    }
    
    changeArrayHandler = dept_code => {
    	/*this.setState({
    		dept_code:[...this.state.dept_code,event.target.value]
    	},() => {
    		console.log(this.state.dept_code)
    	});
    	*/
    	
    	this.setState(
	      { dept_code },
	      () => console.log(`Option selected:`, this.state.dept_code)
	    );
    	
    	
    }
    
    checkNotifyHandler = (event) => {
    	let name = event.target.name;
		let value = event.target.value;
    	this.setState({[name]:value});
    }
    
    applyCoords =(e) =>{
    	console.log(e);
    }
    
	formHandler = (event) => {
			
		event.preventDefault();
		if (googleAnalytics.page.enableGA) {
			let pageTitle = this.state.pageTitle;
			let eventOptions = {
				"category": pageTitle,
				"action": this.state.eventFormAction,
				"label": googleAnalytics.page.action.formSubmitted,
			}
			googleAnalytics.logEvent(eventOptions);
		}
		// var formdata1 = new FormData(event.target);
		// console.log(eventcoords);
		var endalert = $("#end-alert-id").val();
		endalert = endalert.split(" ")[0].split("-")[2]+"-"+endalert.split(" ")[0].split("-")[1]+"-"+endalert.split(" ")[0].split("-")[0]+" "+endalert.split(" ")[1]+":00";
		var notifytransporter = $("#notifyTransporter").prop("checked");
		if(notifytransporter){
			notifytransporter = "yes";
		}
		else{
			notifytransporter = "no";
		}
		var notifyspoc = $("#notifySpoc").prop("checked");
		if(notifyspoc){
			notifyspoc = "yes";
		}
		else{
			notifyspoc = "no";
		}

		var notifyTrucks = $("#notifyTrucks").prop("checked");
		if(notifyTrucks){
			notifyTrucks = "yes";
		}
		else{
			notifyTrucks = "no";
		}

		if(coordinates.length > 0)
		{
			var notifiedFlag = 0;
			var oldStartAlert = this.state.oldStartAlert;
			var oldEndAlert = this.state.oldEndAlert;
			var startAlert = this.state.startAlert;
			var endAlert = endalert;
			if(startAlert != oldStartAlert)
			{
				var notifiedFlag = 1;
			}
			if(endAlert !=oldEndAlert)
			{
				var notifiedFlag = 1;
			}
			var reqparams = {
				event : this.state.event,
				oldEvent : this.state.oldEvent,
				editedEventID : this.state.editedEventID,
				dept_code : this.state.dept_code,
				startAlert : this.state.startAlert,
				coordinates : coordinates,
				endAlert : endalert,
				email : this.state.notifyfirstto,
				emailcc : this.state.notifyfirstcc,
				notifyduration : this.state.notifyduration,
				carrier : this.state.carrier,
				notifytransporter : notifytransporter,
				notifyspoc : notifyspoc,
				user_email : this.state.user_email,
				notifiedFlag : notifiedFlag,
				notifyTrucks: notifyTrucks
			}
			// console.log(coordinates);
			redirectURL.post("/weather/updateweatherevent",reqparams).then((response)=>{
				console.log(response.data.message);
				if(response.data.message == "success"){
					this.setState({
						basicType:"success",
						basicTitle : "Event Updated. Please check again in 10 minutes for alternate routes.",
						show : true
					})
				}
			}).catch(function(error){
				console.log("Error");
			});
			
			// $(".weather-grid").css("display","flex");
			// $(".weather-alert-card").css("display","none");
			// $("#addGeoFence").css("display","block");
			var url = this.state.previousScreenPath;
			// setTimeout(function(){
			// 	window.location.href = url;
			// },1500)
			
		}
		else
		{
			this.setState({
				show:true,
				basicType : "danger",
				basicTitle : "Select Atleast One Area" 
			})
		}
		
		
	}
	closeAlert = () => {
        this.setState({
            show: false
        });
	}
	disableevent(){
		var reqparams = {
			event : document.getElementById("event-id").value,
			editedEventID : this.state.editedEventID,
			dept_code : this.state.dept_code
		}
		console.log(reqparams);
		redirectURL.post("/weather/disableEvent",reqparams).then((response)=>{
			if(response.data.message == "success"){
				this.setState({
					basicType : "success",
					basicTitle : "Disabled Event",
					show:true
				});
			}
		}).catch(function(error){
			console.log(error);
		})
	}
	onRowClicked(params) {
		if(params.colDef.headerName == "Event Status")
		{
			// console.log("IN onRowClicked, params = ",params);
			selectedRowData = params.data;
		}
		else{
			console.log("Other cells");
		}
	}

	handleFilteronLoad(){
    	// console.log("filter clicked");
		// e.preventDefault();
		
		this.setState({
			loadshow:'show-m',
		});
		//console.log("Here ",this.props.match.url);
		var dept;
		if(this.props.match.url == '/nearbyprttrucks')
		{
			dept='LOG-PRT'
		}

		if(this.props.match.url == "/nearbysndtrucks")
		{
			dept='SNDG'
		}
		if(this.props.match.url == "/nearbysctrucks")
		{
			dept='LOG-SC'
		}
		
		var transcode = "ALL";
		
		var trip_type = this.state.triptype.value;
		
		var formdata = {
			radius:3000,
			latitude:"20.73568784876339",
			longitude:"79.38999444931353",
			dept_code:this.state.dept_code,
			transporter_code:"ALL",
			status:"0",
			trip_type : trip_type
		}
		// console.log(formdata);
		var rlatitude="20.73568784876339";
		var rlongitude="79.38999444931353";
		redirectURL.post('/vicinity/getRadiusCoordinates',formdata,{
			headers:{
				'Content-Type':'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
				'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept, Authorization"

			}
		})
		.then(
			(response) =>{
			//console.log("response", JSON.parse(response.data.body));
		
			var markers = JSON.parse(JSON.parse(response.data.apiData.body).trucks_data);
			console.log(JSON.parse(response.data.apiData.body))

			if(markers.length > 0)
			{
				this.setState({
					weatherData: response.data.weatherData,
					// defaultradius:formdata.radius,
					// truckscoordinates:markers,
					// onTripCounter : JSON.parse(response.data.apiData.body).gps_trucks,
					// mwidth:"col-xl-12 col-lg-12",
					// rowData:markers,
					// radius:formdata.radius,
					loadshow:'show-n',
					showform:'show-n',
				});
				// redirectURL.post("/weather/getPlants").then((rsp)=>{
				// 	this.setState({
				// 		plantLocations : rsp.data,
				// 	});
				// 	console.log(rsp.data);
				// 	this.renderMap();
				// })
				
				
			}
			else{
				// this.setState({
				// 	show: true, basicType:'warning', basicTitle:"No Data found.",
				// 	loadshow:'show-n',
				// 	showform:'show-m',
				// });
				
			}
		})
		.catch(function(error){
			console.log(error);
		});
		
		this.renderMap();
	}
	handleFilter(){
    	// console.log("filter clicked");
		// e.preventDefault();
		
		this.setState({
			loadshow:'show-m'
		});
		//console.log("Here ",this.props.match.url);
		var dept;
		if(this.props.match.url == '/nearbyprttrucks')
		{
			dept='LOG-PRT'
		}

		if(this.props.match.url == "/nearbysndtrucks")
		{
			dept='SNDG'
		}
		if(this.props.match.url == "/nearbysctrucks")
		{
			dept='LOG-SC'
		}
		
		var transcode = "ALL";
		
		var trip_type = this.state.triptype.value;
		
		var formdata = {
			radius:3000,
			latitude:"20.73568784876339",
			longitude:"79.38999444931353",
			dept_code:this.state.dept_code,
			transporter_code:"ALL",
			status:"0",
			trip_type : trip_type
		}
		// console.log(formdata);
		var rlatitude="20.73568784876339";
		var rlongitude="79.38999444931353";
		redirectURL.post('/vicinity/getRadiusCoordinates',formdata,{
			headers:{
				'Content-Type':'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
				'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept, Authorization"

			}
		})
		.then(
			(response) =>{
			//console.log("response", JSON.parse(response.data.body));
		
			var markers = JSON.parse(JSON.parse(response.data.apiData.body).trucks_data);
			console.log(JSON.parse(response.data.apiData.body))

			if(markers.length > 0)
			{
				this.setState({
					weatherData: response.data.weatherData,
					defaultradius:formdata.radius,
					truckscoordinates:markers,
					onTripCounter : JSON.parse(response.data.apiData.body).gps_trucks,
					mwidth:"col-xl-12 col-lg-12",
					rowData:markers,
					radius:formdata.radius,
					//loadshow:'show-n',
					showform:'show-n',
					showrefresh:'show-m',
					rlatitude:formdata.latitude,
					rlongitude:formdata.longitude,
				});
				redirectURL.post("/weather/getPlants").then((rsp)=>{
					this.setState({
						plantLocations : rsp.data,
					});
					this.renderMap();
				})
				
				
			}
			else{
				this.setState({
					show: true, basicType:'warning', basicTitle:"No Data found.",
					loadshow:'show-n',
					showform:'show-m',
				});
				
			}
		})
		.catch(function(error){
			console.log(error);
		});
		
		// this.renderMap();
	}
	setTripType = triptype =>{
		this.setState(
			{ triptype },
			() => {
				console.log(`Option selected:`, this.state.triptype)
				this.handleFilter()
				
				setTimeout(() => {
					this.setState({
						loadshow:"show-n",
						overlay:"show-n",
					})
				}, 10000)
			}
		  );
	}
	onClickShowTrucks = async () =>{
		// console.log("Here again ", this.state.showtruckopts)
		await this.setState({
			setshow:!this.state.setshow
		})
		await this.onLOadShowTrucks();	
	}
	onLOadShowTrucks(){
		if(this.state.setshow == true)
		{
			console.log(1);
			this.setState({
				showtruckopts:"show-m",
				loadshow:"show-m",
				overlay:"show-m",
			})
			this.handleFilter();
			setTimeout(() => {
				this.setState({
					loadshow:"show-n",
					overlay:"show-n",
				})
			}, 10000)
		}
		else
		{
			console.log(2);

			this.setState({
				showtruckopts:"show-n",
				weatherData: this.state.weatherData,
				defaultradius:this.state.defaultradius,
				plantLocations : [],
				truckscoordinates:[]
			})
			this.renderMap();
		}
	}
	
	onClickWeatherForecast(e){
	
		this.setState({displayWeatherForecast: !this.state.displayWeatherForecast});
		this.renderMap();
		// weather forecast
		// console.log(this.state.displayWeatherForecast, "displayWeatherForecast")
		
		// else{
		// 	if(this.state.weatherMarkers.length){
		// 		this.state.weatherMarkers.map((e)=>{
		// 			e.marker.setVisible(false)
		// 		})
		// 		this.setState({
		// 			weatherMarkers: []
		// 		})
		// 	}
		// }
	}

	
	onClickFilterWeather(clickedType)
	{
		var weatherMarkers = this.state.weatherMarkers;
		if(clickedType == 1){
			weatherMarkers.map((e)=>{
				e.marker.setVisible(true);
			})
		}
		else if(clickedType == 2)
		{
			weatherMarkers.map((e)=>{
				if (e.desc == "Heavy Rain")
				{
					e.marker.setVisible(true);
				}
				else 
				{
					e.marker.setVisible(false);
				}
			})
		}
		else if(clickedType == 3)
		{
			weatherMarkers.map((e)=>{
				if (e.desc.includes("Winds"))
				{
					e.marker.setVisible(true);
				}
				else 
				{
					e.marker.setVisible(false);
				}
			})
		}
		else if(clickedType == 4)
		{
			weatherMarkers.map((e)=>{
				if (e.desc.includes("Thunderstorm"))
				{
					e.marker.setVisible(true);
				}
				else 
				{
					e.marker.setVisible(false);
				}
			})
		}
		else if(clickedType == 5)
		{
			weatherMarkers.map((e)=>{
				if (e.desc.includes("Hailstrom"))
				{
					e.marker.setVisible(true);
				}
				else 
				{
					e.marker.setVisible(false);
				}
			})
		}
		else if(clickedType == 6)
		{
			weatherMarkers.map((e)=>{
				if (e.desc.includes("Cyclone"))
				{
					e.marker.setVisible(true);
				}
				else 
				{
					e.marker.setVisible(false);
				}
			})
		}
		else if(clickedType == 7)
		{
			weatherMarkers.map((e)=>{
				if (e.desc.includes("Sandstorm"))
				{
					e.marker.setVisible(true);
				}
				else 
				{
					e.marker.setVisible(false);
				}
			})
		}
	}

    render(){

    	const dStyles={
				width:'100%',
				height:'550px'
		}
		const wstyles={
			"paddingTop": '12px',
			"paddingRight": '29px',
			"paddingBottom": '2px',
		}
    	
        
        return (
            <div className="container-fluid">
				<SweetAlert
				show={this.state.show}
				type={this.state.basicType}
				title={this.state.basicTitle}
				onConfirm={this.closeAlert}
				>
				</SweetAlert>
            	<div className="row">
            		<div className="col-xl-12 col-lg-12">
		            	<div className="card">
		            	
			                <div className="card-header">
				       			<h5>
				       				<i className="icon-map cus-i"></i> <span>Edit Emergency Event</span>							
									   {/* <a href={this.state.previousScreenPath} className="btn btn-warning" id="previous-screen" style={{padding: "9px",float: "right",width: "87px"}}><i className="fa fa-arrow-left"></i> Back</a> */}
									   <a href="/sndweatheralerts" className="btn btn-warning" id="previous-screen" style={{padding: "9px",float: "right",width: "87px"}}><i className="fa fa-arrow-left"></i> Back</a>
									   {/* <a href="#" className="btn btn-success pull-right cs-btn" id="addGeoFence" style={{color:"white"}}> <i className="icon-plus"></i> Add Geo Fence</a> */}
				       			</h5>
				   			</div>
				   			<div className="row weather-alert-card" style={wstyles}>
								<form className=" theme-form col-xl-4 col-lg-4" onSubmit={this.formHandler}>
	                    			<div className="col-xl-12 col-lg-12">
										<div className="form-group"> 
                                            <label className="c-lbl">Event Name *:</label>
                                            <input type="textarea" name="event" id="event-id" onChangeCapture={this.checkHandler}  autoComplete="off"  className="form-control" placeholder="Event Name"  required />
                                        </div>
										<div className="row">
											<div className="col-sm-6">
												<div className="form-group">
													<label className="c-lbl">Start Alert (From) *:</label>
													<input type="text" name="startAlert" id="start-alert-id" onBlur={this.startAlertFormat} autoComplete="off" className="form-control datetimepicker_mask" required/>
												</div>
											</div>
											<div className="col-sm-6">
												<div className="form-group">
													<label className="c-lbl">End Alert (To) *:</label>
													<input type="text" name="endAlert" onBlur={this.endAlertFormat} id="end-alert-id" autoComplete="off" className="form-control datetimepicker_mask" required/>
												</div>
											</div>
										</div>
                                        <div className="form-group"> 
                                            <label className="c-lbl">Notify via Email (To) *:</label>
                                            <input type="textarea" name="notifyfirstto" id="notifyFirst" onChangeCapture={this.checkHandler}  autoComplete="off"  className="form-control" placeholder=""  required />
                                        </div>
                                        <div className="form-group"> 
                                            <label className="c-lbl">Notify via Email (cc) *:</label>
                                            <input type="textarea" name="notifyfirstcc" id="notifyFirstcc" onChangeCapture={this.checkHandler} autoComplete="off"  className="form-control" placeholder=""  />
                                        </div>
										<div className="row">
											<div className="col-sm-6">
												<div className="form-group"> 
													<label className="c-lbl">Alert Duration (Hours) *:</label>
													<input type="number" name="notifyduration" id="notify-duration-id" autoComplete="off" onChange={this.checkHandler}  className="form-control" placeholder=""  required />
												</div>
											</div>
										  	<div className="col-sm-6">
												<div className="form-group">
													<label className="c-lbl">Carrier Type *:</label>
													<Select onChange={this.changeHandler.bind(this)} id="select-carrier-id" value={{value:this.state.carrier,label:this.state.carrier}} style={{borderRadius:"0px"}} options={carrieroptions} required />
												</div>
											</div>
										</div>
                                        <div className="form-group">
					               			<label className="c-lbl">Notify Transporter : </label>
					               			&nbsp;&nbsp;
											
											<input type="checkbox" name="notifyTransporter" id="notifyTransporter" />
											
					               	   </div>
										<div className="form-group">
					               			<label className="c-lbl">Notify SPOC : </label>
					               			&nbsp;&nbsp;
											<input type="checkbox" name="notifySpoc" id="notifySpoc" />
					               	   	</div>
										<div className="form-group">
					               			<label className="c-lbl">Notify when trucks move out of Geofence : </label>
					               			&nbsp;&nbsp;
											<input type="checkbox" name="notifyTrucks" id="notifyTrucks" />
					               	   	</div>
										<div className="form-group">
					               			<button type="submit" className="btn btn-success cs-btn" id="saveevent">Save</button>
					               			<a href="#" className="btn btn-info cs-btn" onClick={this.disableevent}>Disable Event</a>
					               		</div>
									</div>
									
				           		</form>
				           		<div className="col-xl-8 col-lg-8">
								
									{this.state.erroMessage == '' ? '':
											<div className="alert alert-danger"></div>
									}
									<div className="row">
										<div className="col-xl-2 col-lg-2">
											<input type="checkbox" className=" mt-10p" onClick={this.onClickShowTrucks.bind(this)} /> Show Trucks
										</div>
										<div className={"col-xl-5 col-lg-5 mb-20p "+(this.state.showtruckopts)}>										
											<Select placeholder="Select Trip Type"
												isMulti={false}
												value={this.state.triptype}
												onChange={this.setTripType.bind(this)} 
												options={(this.state.deptcode == "LOG-SC")?[{"value":1,"label":"ALL"}]:
												[{"value":1,"label":"ALL"},{"value":2,"label":"On Trip"},{"value":5,"label":"Waiting at Dealer"},{"value":3,"label":"Empty / Non-VE trip"}]
												} 
											required/>
										</div>
										<div className="col-xl-5 col-lg-5">
											<input type="checkbox" className=" mt-10p" onChange={this.onClickWeatherForecast.bind(this)} name="showweathers" id="showweathers" /> Show Today Weather Forecast
											
										</div>
									</div>
									  
				               		<div id="map_canvas" className="col-xl-12 col-lg-12" style={dStyles}></div>
									   {(this.state.displayWeatherForecast)?
									<div className="col-sm-12 col-xs-12 col-md-12 map-legends row" style={{ marginTop: "10px",marginLeft: "10px"}}>
										{/* <div className="col-xl-12 col-lg-12"> */}
											<div className="col-sm-2 col-xs-2 col-md-2">
												<img src={require('../../assets/icons/snowy.png')} style={{cursor: "pointer"}} onClick={this.onClickFilterWeather.bind(this, 1)}></img> <figcaption>ALL</figcaption>
											</div>
											<div className="col-sm-2 col-xs-2 col-md-2">
												<img src={require('../../assets/icons/Heavyrain.png')} style={{cursor: "pointer"}} onClick={this.onClickFilterWeather.bind(this, 2)}></img> <figcaption>Heavy Rain</figcaption>
											</div>
											<div className="col-sm-2 col-xs-2 col-md-2">
												<img src={require('../../assets/icons/wind.png')} style={{cursor: "pointer"}} onClick={this.onClickFilterWeather.bind(this, 3)}></img>&nbsp;&nbsp; <figcaption>Heavy Rain & Winds</figcaption>
											</div>
											<div className="col-sm-2 col-xs-2 col-md-2">
												<img src={require('../../assets/icons/thunderstorm.png')} style={{cursor: "pointer"}} onClick={this.onClickFilterWeather.bind(this, 4)}></img><figcaption> Thunderstorm </figcaption>
											</div>
											<div className="col-sm-2 col-xs-2 col-md-2">
												<img src={require('../../assets/icons/hailstorm.png')} style={{cursor: "pointer"}} onClick={this.onClickFilterWeather.bind(this, 5)}></img>&nbsp;<figcaption> Hailstorm </figcaption>
											</div>
											<div className="col-sm-2 col-xs-2 col-md-2">
												<img src={require("../../assets/icons/cyclone.png")} style={{cursor: "pointer"}} onClick={this.onClickFilterWeather.bind(this, 6)}></img>&nbsp;&nbsp; <figcaption>Cyclone</figcaption>
											</div>
											<div className="col-sm-2 col-xs-2 col-md-2">
												<img src={require('../../assets/icons/sandstorm.png')} style={{cursor: "pointer"}} onClick={this.onClickFilterWeather.bind(this, 7)}></img><figcaption> Sandstorm </figcaption>
											</div>
										{/* </div> */}
									</div>
									:""}
				 	               <div className="col-xl-12 col-lg-12">
				 					  <input type="hidden" name="coords" id="coords" value={this.state.coords} />
				 				   </div>
				               		
			               		</div>
			           		</div>
		           		</div>
	           		</div>
                </div>
				<input type="text" name="search" className="col-xl-6 col-lg-6 form-control mt-5p" id="search" placeholder="Enter Address to search" />
				<div className={"dataLoadpage " +(this.state.loadshow)}>
				</div>
				<div className={"dataLoadpageimg " +(this.state.loadshow)}>
					<div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
				</div>
				<div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>
                
        );
    }
}
function loadScript(url){
    var index  =window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src=url
    script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}
                   
function timeConvert(n) {
	var num = n;
	var hours = (num / (3600));
	var rhours = Math.floor(hours);
	var minutes = (n) / (60);
	var rminutes = Math.round(minutes);
	return rhours + " hour(s) and " + rminutes + " minute(s).";
}                              
var currentinfowindow = null;
function getTimeInfo(marker,timedet,coords)
{
	var timeinfo = new window.google.maps.InfoWindow({
          content: "Time at this location: " + timedet
        });

	marker.addListener('click', function() {
		
				if (currentinfowindow != null) {
					currentinfowindow.close();
					currentinfowindow = timeinfo;
					timeinfo.open(marker.get('map'), marker);
				}
				else
				{
					currentinfowindow = timeinfo;
					timeinfo.open(marker.get('map'), marker);
				}
				
        });
}


 function clearSelection() {
	    if (selectedShape) {
	      selectedShape.setEditable(false);
	      selectedShape = null;
	    }
	  }

	 function setSelection(shape) {
	    clearSelection();
	    selectedShape = shape;
	    //console.log("selectedShape",selectedShape);
	    shape.setEditable(true);
	    
	    selectColor(shape.get('fillColor') || shape.get('strokeColor'));
	  }

  function deleteSelectedShape() {
		fencingLength=0;  
	    if (selectedShape) {
	      selectedShape.setMap(null);
	    }
	    // To show:
	     drawingManager.setOptions({
	       drawingControl: true
	     });
	  }

	  
	 function selectColor(color) {
	      selectedColor = color;
	      for (var i = 0; i < colors.length; ++i) {
	        var currColor = colors[i];
	        //console.log(colorButtons[currColor]);
	        //colorButtons[currColor].style.border = currColor == color ? '1px solid #789' : '1px solid #fff';
	      }

	      // Retrieves the current options from the drawing manager and replaces the
	      // stroke or fill color as appropriate.
	      var polylineOptions = drawingManager.get('polylineOptions');
	      polylineOptions.strokeColor = color;
	      drawingManager.set('polylineOptions', polylineOptions);

	      var rectangleOptions = drawingManager.get('rectangleOptions');
	      rectangleOptions.fillColor = color;
	      drawingManager.set('rectangleOptions', rectangleOptions);

	      var circleOptions = drawingManager.get('circleOptions');
	      circleOptions.fillColor = color;
	      drawingManager.set('circleOptions', circleOptions);

	      var polygonOptions = drawingManager.get('polygonOptions');
	      polygonOptions.fillColor = color;
	      drawingManager.set('polygonOptions', polygonOptions);
	    }

	function setSelectedShapeColor(color) {
	      if (selectedShape) {
	        if (selectedShape.type == window.google.maps.drawing.OverlayType.POLYLINE) {
	          selectedShape.set('strokeColor', color);
	        } else {
	          selectedShape.set('fillColor', color);
	        }
	      }
	    }

	  function makeColorButton(color) {
	      var button = document.createElement('span');
	      button.className = 'color-button';
	      button.style.backgroundColor = color;
	      window.google.maps.event.addDomListener(button, 'click', function() {
	        selectColor(color);
	        setSelectedShapeColor(color);
	      });

	      return button;
	    }

	  function buildColorPalette() {
	       var colorPalette = document.getElementById('color-palette');
	       for (var i = 0; i < colors.length; ++i) {
	         var currColor = colors[i];
	         var colorButton = makeColorButton(currColor);
	         colorPalette.appendChild(colorButton);
	         colorButtons[currColor] = colorButton;
	       }
	       selectColor(colors[0]);
	     }  
	  
	 function getSelectedShape(coords){
		var lt=[]
		//console.log("coordsLatlngs ",coords);
		for (let value of Object.values(coords)) {
		  //console.log("Val is ",value); // John, then 30
		  lt.push(value)
		}
		//console.log("Combine ",lt);
		document.getElementById('coords').value=lt;
		//return lt;
	}


    function loadDateTimeScript(){
        // alert("timeDate");
        $('.datetimepicker_mask').datetimepicker({
            //mask:'39-19-9999 29:59',
            format:'d-m-Y H:i',
        });
        $('.datetimepicker_date').datetimepicker({
            //mask:'39-19-9999',
            format:'d-m-Y',
            timepicker:false
        });
        var index  =window.document.getElementsByTagName("script")[1]
        var script = window.document.createElement("script")
        script.src="https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
        //script.src="http://xdsoft.net/jqplugins/datetimepicker/"
        script.async=true
        script.defer = true
        index.parentNode.insertBefore(script,index)
    }

$(document).ready(function(){
    $(document).on("keyup","#notifyFirst",function(e){
        // alert($(this).val());
        if(e.which === 32){
            $(this).val($(this).val()+", ");
        }

	});
	$(document).on("keyup","#notifyFirstcc",function(e){
        // alert($(this).val());
        if(e.which === 32){
            $(this).val($(this).val()+", ");
        }

	});
	$("#addGeoFence").click(function(){
		$(".weather-grid").css("display","none");
		$(".weather-alert-card").css("display","flex");
		$(this).css("display","none");
	});
	$(document).on("keyup","#notify-duration-id",function(){
		if($(this).val() < 1)
		{
			$(this).val("");
		}
	})
});

function getPolygonCoords()
{
	// console.log("function ", geoFencingAreaArr);
	if(geoFencingAreaArr.length > 0)
	{
		coordinates = [];
		for(var g=0; g<geoFencingAreaArr.length;g++)
		{

			var len = geoFencingAreaArr[g].getPath().getLength();
			console.log(len);
			var htmlStr = "";
			var newcoordinates=[];
			for (var i = 0; i < len; i++) {
				// var latlngd = {"lat":parseFloat(each_lat_lng[0]),"lng":parseFloat(each_lat_lng[1])};
				// coordinates.push()
				var strlatlng = geoFencingAreaArr[g].getPath().getAt(i).toUrlValue(5);
				var spliting = strlatlng.split(",");
				var latlngd = {"lat":parseFloat(spliting[0]),"lng":parseFloat(spliting[1])};
				newcoordinates.push(latlngd);
			// htmlStr += "new google.maps.LatLng(" + currFencing.getPath().getAt(i).toUrlValue(5) + "), ";
			//Use this one instead if you want to get rid of the wrap > new google.maps.LatLng(),
			//htmlStr += "" + currFencing.getPath().getAt(i).toUrlValue(5);
			}
			coordinates.push(newcoordinates)
		}
		console.log(coordinates);
	}
	// var len = geoFencingAreaArr.getPath().getLength();
	// console.log(len);
	// var htmlStr = "";
	// var newcoordinates=[];
	// for (var i = 0; i < len; i++) {
	// 	// var latlngd = {"lat":parseFloat(each_lat_lng[0]),"lng":parseFloat(each_lat_lng[1])};
	// 	// coordinates.push()
	// 	var strlatlng = geoFencingArea.getPath().getAt(i).toUrlValue(5);
	// 	var spliting = strlatlng.split(",");
	// 	var latlngd = {"lat":parseFloat(spliting[0]),"lng":parseFloat(spliting[1])};
	// 	newcoordinates.push(latlngd);
	// // htmlStr += "new google.maps.LatLng(" + currFencing.getPath().getAt(i).toUrlValue(5) + "), ";
	// //Use this one instead if you want to get rid of the wrap > new google.maps.LatLng(),
	// //htmlStr += "" + currFencing.getPath().getAt(i).toUrlValue(5);
	// }
	// coordinates.push(newcoordinates)
	// console.log("htmlStr", coordinates);
	
}

function getnewPolygonCoords()
{
	console.log("function");
	var len = geoFencingArea.getPath().getLength();
	console.log(len);
	// 	var htmlStr = "";
	var newcoordinates=[];
	for (var i = 0; i < len; i++) {
		// var latlngd = {"lat":parseFloat(each_lat_lng[0]),"lng":parseFloat(each_lat_lng[1])};
		// coordinates.push()
		var strlatlng = geoFencingArea.getPath().getAt(i).toUrlValue(5);
		var spliting = strlatlng.split(",");
		var latlngd = {"lat":parseFloat(spliting[0]),"lng":parseFloat(spliting[1])};
		newcoordinates.push(latlngd);
	// htmlStr += "new google.maps.LatLng(" + currFencing.getPath().getAt(i).toUrlValue(5) + "), ";
	//Use this one instead if you want to get rid of the wrap > new google.maps.LatLng(),
	//htmlStr += "" + currFencing.getPath().getAt(i).toUrlValue(5);
	}
	coordinates.push(newcoordinates)
	// console.log("htmlStr", coordinates);
	
}


